
import { IProduktdefinition } from "./IProduktdefinition";

import { UntypedFormGroup } from "@angular/forms";
import { ProduktmatrisGrid } from "../produktinstruktioner-details/matris/ProduktmatrisGrid";
import { ProduktdefinitionHeaderData } from "./ProduktdefinitionHeaderData";
import { ProduktdefinitionViewModel } from "./ProduktdefinitionViewModel";
import { Begransningsmatris } from "./matriser/Begransningsmatris";
import { FargmarkningMatris } from "./matriser/FargmarkningMatris";
import { Fordelningsmatris } from "./matriser/Fordelningsmatris";
import { RadprisjusteringarMatris } from "./matriser/RadprisjusteringarMatris";
import { Stolpmatris } from "./matriser/Stolpmatris";
import { Vardematris } from "./matriser/Vardematris";

export class ProduktdefinitionMatrisdata {
    grid: ProduktmatrisGrid;
    canEdit = true;
    fargmarkningMatris: FargmarkningMatris;
    fordelningsmatris: Fordelningsmatris;
    radprisjusteringarMatris: RadprisjusteringarMatris;
    stolpmatris: Stolpmatris;
    vardematris: Vardematris;
    begransningsmatris: Begransningsmatris;

    constructor(
        model: IProduktdefinition,
        form: UntypedFormGroup,
        headerData: ProduktdefinitionHeaderData,
        canEdit: boolean,
        defaultRadprisValue: () => number,
        ovriga: ProduktdefinitionViewModel[] = []) {
        this.grid = new ProduktmatrisGrid(model, form, defaultRadprisValue, ovriga.map(x => x.matrisdata.grid));
        this.canEdit = canEdit;

        this.fargmarkningMatris = new FargmarkningMatris(this.grid, form, headerData, this.canEdit);
        this.fordelningsmatris = new Fordelningsmatris(this.grid, form, headerData, this.canEdit);
        this.radprisjusteringarMatris = new RadprisjusteringarMatris(this.grid, form, headerData, this.canEdit, defaultRadprisValue);
        this.stolpmatris = new Stolpmatris(this.grid, form, headerData, this.canEdit);
        this.vardematris = new Vardematris(this.grid, form, headerData, this.canEdit);
        this.begransningsmatris = new Begransningsmatris(this.grid, form, headerData, this.canEdit);
    }

    mapToDto(model: IProduktdefinition) {
        model.langdklass = this.grid.langdklasser.map(p => ({
            overmal: p.overmal,
            startlangd: p.startlangd,
            stolpMaxRotdiameter: p.stolpMaxRotdiameter,
            stolpMinRotdiameter: p.stolpMinRotdiameter
        }));

        model.diameterklass = this.grid.diameterklasser.map(p => ({
            startdiameter: p.startdiameter,
            radpris: p.radpris,
            radprisJustering: p.radprisJustering.map(y => ({
                startlangd: y.startlangd,
                justering: y.justering
            }))
        }));

        model.produktmatris = this.grid.getCells().map(pm => pm.mapToDto());
    }
}
